import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../../shared.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-prompt-dialog',
  templateUrl: './prompt-dialog.component.html',
  styleUrl: './prompt-dialog.component.scss',
  standalone: true,
  imports: [SharedModule,MatIconModule,MatDialogModule,MatButtonModule,CommonModule],
})
export class PromptDialogComponent {
  @Output() buttonClicked = new EventEmitter<string>();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<PromptDialogComponent>
  ) {}

  onNoClick() {
    this.dialogRef.close();
  }

  onButtonClick(buttonName: string) {
    this.buttonClicked.emit(buttonName);
  }
}
